export default __webpack_public_path__ + "2e640565b80d28aa3fd335136ca2ac8a.svg";